import React, { useState } from 'react';

export function PinButton({ onPin }) {
  const [showOptions, setShowOptions] = useState(false);

  const handlePin = (duration) => {
    console.log('PinButton handlePin:', duration); 
    onPin(duration);
    setShowOptions(false);
  };

  return (
    <div className="relative">
      {showOptions ? (
        <div className="absolute right-0 top-0 bg-white shadow-lg rounded-lg p-2 border z-20">
          <div className="flex flex-col gap-2">
            <button
              onClick={() => handlePin(null)}
              className="text-sm px-3 py-1 text-gray-700 hover:bg-gray-100 rounded"
            >
              Pin Indefinitely
            </button>
            <button
              onClick={() => handlePin(10)}
              className="text-sm px-3 py-1 text-gray-700 hover:bg-gray-100 rounded"
            >
              10 seconds
            </button>
            <button
              onClick={() => handlePin(600)}
              className="text-sm px-3 py-1 text-gray-700 hover:bg-gray-100 rounded"
            >
              10 minutes
            </button>
            <button
              onClick={() => handlePin(1800)}
              className="text-sm px-3 py-1 text-gray-700 hover:bg-gray-100 rounded"
            >
              30 minutes
            </button>
            <button
              onClick={() => handlePin(3600)}
              className="text-sm px-3 py-1 text-gray-700 hover:bg-gray-100 rounded"
            >
              1 hour
            </button>
            <button
              onClick={() => setShowOptions(false)}
              className="text-sm px-3 py-1 text-red-600 hover:bg-red-50 rounded border-t"
            >
              Cancel
            </button>
          </div>
        </div>
      ) : (
        <button
          onClick={() => setShowOptions(true)}
          className="p-1 text-gray-500 hover:text-blue-500 transition-colors"
          title="Pin message"
        >
          <span className="text-lg">📌</span>
        </button>
      )}
    </div>
  );
}